import React from "react";
import { Row} from "react-bootstrap";

const BottomHero = (props) => (
    <Row>
        <img src='images/home-bottom-hero@2x.jpg' alt="" className="img-responsive" />
    </Row>
)

export default BottomHero;


// WEBPACK FOOTER //
// ./src/components/BottomHero.js